import React, { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function Clock() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  // LGS sınavı tarihi: 14 Haziran 2026
  const examDate = new Date('2026-06-14');
  const difference = examDate.getTime() - time.getTime();
  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  return <div className="flex flex-col items-center space-y-2" data-id="element-218">
      <div className="text-4xl sm:text-6xl font-bold text-white font-mono tracking-wider" data-id="element-219">
        {time.toLocaleTimeString('tr-TR', {
        hour: '2-digit',
        minute: '2-digit'
      })}
      </div>
      <div className="text-gray-400 text-center flex flex-col sm:block" data-id="element-220">
        <span data-id="element-221">
          {time.toLocaleDateString('tr-TR', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </span>
        <span className="text-purple-400 mt-1 sm:mt-0 sm:ml-2" data-id="element-222">
          (LGS'ye {days} gün {hours} saat)
        </span>
      </div>
    </div>;
}
export function YoneticiHeader() {
  const navigate = useNavigate();
  return <header className="w-full bg-[#0D1117]/80 backdrop-blur-md border-b border-gray-800/40" data-id="element-223">
      {/* Top Header Row */}
      <div className="flex items-center justify-between w-full px-8 py-4" data-id="element-224">
        {/* Welcome Text with Aurora Gradient Effect for the name - Updated with larger text and formal greeting */}
        <div className="text-2xl text-white" data-id="element-225">
          Hoş geldiniz,{' '}
          <span className="font-medium bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 text-transparent bg-clip-text" data-id="element-226">
            Ahmet Bey
          </span>
        </div>
        {/* Right Icons - Increased size by 50% */}
        <div className="flex items-center space-x-8" data-id="element-227">
          {/* Notification Bell - Larger size */}
          <button onClick={() => navigate('/yonetici/bildirimler')} className="relative hover:text-white transition-colors p-1" data-id="element-228">
            <Bell className="w-10 h-10 text-purple-400 hover:text-white transition-colors" data-id="element-229" />
            <span className="absolute -top-1 -right-1 flex h-4 w-4" data-id="element-230">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75" data-id="element-231"></span>
              <span className="relative inline-flex rounded-full h-4 w-4 bg-purple-500" data-id="element-232"></span>
            </span>
          </button>
          {/* User Profile - Larger size */}
          <button onClick={() => navigate('/yonetici/profil')} className="relative" data-id="element-233">
            <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&crop=faces" alt="Yönetici Profili" className="h-16 w-16 rounded-full object-cover ring-2 ring-purple-500/50" data-id="element-234" />
          </button>
        </div>
      </div>
      {/* Middle Header Row with Clock */}
      <div className="py-5" data-id="element-235">
        <Clock data-id="element-236" />
      </div>
    </header>;
}